<!--
  * name: AppFooter
  * description: Footer 컴포넌트
-->
<template>
  <div>
    <footer class="footer-main">
      <div class="container in-wrap">
        <nav id="GoGMenu" class="row justify-content-md-start">
          <div class="col-lg-2 col-md-3 unit">
            <div class="head-wrap">
              <h2 class="tit">Customer Support</h2>
            </div>
            <ul class="menu">
              <li><a :href="`${rimanLink}/faq`" target="_blank">자주묻는질문</a></li>
              <li><a :href="`${rimanLink}/request`" target="_blank">문의하기</a></li>
              <li><a :href="`${rimanLink}/office`" target="_blank">사옥 소개</a></li>
              <li><a :href="`${rimanLink}/cibi`" target="_blank">CI/BI 소개</a></li>
              <li>
                <a href="" @click.prevent="openBeautyPlanner">뷰티플래너 조회</a>
              </li>
              <li><a :href="`${rimanLink}/library`" target="_blank">Library</a></li>
            </ul>
          </div>
          <div class="col-lg-2 col-md-3 unit">
            <div class="head-wrap">
              <h2 class="tit">Official Website</h2>
            </div>
            <ul class="menu">
              <li><a :href="rimanLink" target="_blank">RIMAN KOREA</a></li>
              <li><a :href="incelldermLink" target="_blank">INCELLDERM</a></li>
              <li><a :href="botalabLink" target="_blank">botalab</a></li>
              <li><a :href="lifeningLink">Lifening</a></li>
            </ul>
          </div>
          <div class="col-lg-2 col-md-3 unit">
            <div class="head-wrap">
              <h2 class="tit">Social Media</h2>
            </div>
            <ul class="menu">
              <li>
                <a
                  href="https://www.youtube.com/channel/UCgFWSkmvaAWcVBaVanKpDYw"
                  target="_blank"
                  >RIMAN KOREA Youtube</a
                >
              </li>
              <li>
                <a href="https://www.instagram.com/incellderm.official" target="_blank"
                  >INCELLDERM Instagram</a
                >
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UChczyeup2UQz4wGpebbMckA"
                  target="_blank"
                  >INCELLDERM Youtube</a
                >
              </li>
              <li>
                <a
                  href="https://www.instagram.com/botalab.official"
                  target="_blank"
                  >botalab Instagram</a
                >
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UCDfIKM3yZL25ZLdUbWQLVcQ"
                  target="_blank"
                  >botalab Youtube</a
                >
              </li>
              <li>
                <a
                  href="https://www.instagram.com/lifening.official/"
                  target="_blank"
                  >Lifening Instagram</a
                >
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UCML_CB7lGSHomVqcSAWvLag"
                  target="_blank"
                  >Lifening Youtube</a
                >
              </li>
            </ul>
          </div>
          <div class="col-lg-2 col-md-3 unit">
            <div class="head-wrap">
              <h2 class="tit">Privacy &amp; Terms</h2>
            </div>
            <ul class="menu">
              <li><a :href="`${rimanLink}/agreement/tos`" target="_blank">이용약관</a></li>
              <li><a :href="`${rimanLink}/agreement/privacypolicy`" target="_blank">개인정보처리방침</a></li>
            </ul>
          </div>
        </nav>
        <address class="address" :class="{open: isFoot}">
          <span>(주)리만코리아</span> <span>사업자번호 : 272-81-02126</span> 대표
          : 김경중 <br />
          <span>대구광역시 수성구 동대구로 86 리만타워 5,6층</span>
          통신판매업신고 : 2021-대구수성구-0130<br />
          <span>판매점 운영지원센터 : 1899-5940</span>
          <span>뷰티플래너 통합지원센터 : 1522-8144</span> FAX : 053-767-0225,
          053-719-0225
        </address>
        <p class="copy pc">Copyright © 2021 RIMANKOREA. ALL RIGHTS RESERVED</p>
        <p class="copy mo" :class="{open: isFoot}" @click="openFootFunc">Copyright © 2021 RIMANKOREA. ALL RIGHTS RESERVED</p>
      </div>
    </footer>
    <scroll-top-button :class="{footOpen: isFoot}" />
  </div>
</template>

<script>
import ScrollTopButton from '@/components/page/ScrollTopButton.vue';
import BpPopup from './BpPopup.vue'; /* 병헌 220208 푸터 > 서포트 > 뷰티플래너조회 > 외부팝업 -> 내부팝업 변경, 추가 */

export default {
  name: 'AppFooter',
  methods: {
    // ## 뷰티플래너 호출 메소드
    openBeautyPlanner() {
      this.$emit('openBpPopup', 'bpPopup'); /* 병헌 220208 푸터 > 서포트 > 뷰티플래너조회 > 외부팝업 -> 내부팝업 변경, 추가 */
    },
    openFootFunc() {
      this.isFoot = !this.isFoot;
      this.$emit('openFootGo', this.isFoot);
    },
  },
  components: {
    ScrollTopButton,
    BpPopup, /* 병헌 220208 푸터 > 서포트 > 뷰티플래너조회 > 외부팝업 -> 내부팝업 변경, 추가 */
  },
  data() {
    return {
      incelldermLink: `${process.env.VUE_APP_INCELLDERM_URL}`,
      botalabLink: `${process.env.VUE_APP_BOTALAB_URL}`,
      rimanLink: `${process.env.VUE_APP_RIMAN_URL}`,
      lifeningLink: `${process.env.VUE_APP_LIFENING_URL}`,
      isFoot: false,
    };
  },
};
</script>

<style lang='scss' scoped>
@media (max-width: $mobile-size) {
  .address{
    display: none;
    &.open{
      display: block;
    }
  }
}
.copy{
  &.pc{
      display: block;
    }
    &.mo{
      display: none;
    }
  @media (max-width: $mobile-size) {
    background: url(~@/assets/images/common/arrow_down_white.svg) no-repeat right .4rem;
    &.pc{
      display: none;
    }
    &.mo{
      display: block;
    }
  }
  &.open{
    background-image: url(~@/assets/images/common/arrow_up_white.svg);
  }
}
</style>
